// extracted by mini-css-extract-plugin
module.exports = {"Security":"Security_Security__2srZk","card":"Security_card__1i_l9","icon":"Security_icon__5hUvs","actions":"Security_actions__9yhv7"};